import { ComponentType } from "react";

export default function CustomErrorMessage({ children }: { children?: any }) {
  return (
    <span className="d-block captions mt-2">{children}</span>
  );
}
